export interface IGooglePlayConnectApiSettings {
  id: string;
  name: string;
  publishType?: EGooglePlayPublishType;
  appetizeApiToken?: string;
  configIds?: string[];
}

export enum EGooglePlayPublishType {
  Apk = 0,
  Simulator = 1,
  AAB = 2
}
